import { MOBILE_BREAKPOINT_PX } from '@km3d/shared/constants';

export interface DeviceHints {
  innerWidth: number;
  saveData?: boolean | undefined;
  effectiveType?: string | undefined;
}

/**
 * PLAN §7 korak 5: `mobile` na uskom ekranu, uz Save-Data ili na 2g/3g vezi; inače `desktop`.
 * `forced` (atribut `variant`) ima prednost.
 */
export function chooseVariant(hints: DeviceHints, forced?: string | null): 'mobile' | 'desktop' {
  if (forced === 'mobile' || forced === 'desktop') return forced;
  if (hints.innerWidth < MOBILE_BREAKPOINT_PX) return 'mobile';
  if (hints.saveData) return 'mobile';
  if (hints.effectiveType && /(^|-)(2g|3g)$/.test(hints.effectiveType)) return 'mobile';
  return 'desktop';
}

/** Da li je `expiresAt` (unix s) prošao ili ističe za manje od `marginSec`. */
export function isExpired(expiresAt: number, nowMs: number, marginSec = 30): boolean {
  return expiresAt - marginSec <= Math.floor(nowMs / 1000);
}

/** Razlog iz odgovora `/v1/resolve` za `km3d:unavailable`. */
export function reasonFromStatus(status: number, error: string | undefined): string {
  if (error) return error;
  if (status === 404) return 'not_found';
  if (status === 403) return 'forbidden';
  if (status === 429) return 'rate_limited';
  return 'error';
}
